import React from 'react';
import styled from 'styled-components';
import Button from 'material-ui/Button';
import classes from './Menu.css';

const IconContainer = styled.span`
    margin-right: 0.5em;

    & svg {
        font-size: 20px;
    }
`;

const MenuButton = ({ icon, label, open, onClick, children }) => {
    return (
        <Button
            aria-owns={open ? 'menu-list-grow' : null}
            aria-haspopup="true"
            onClick={onClick}
            className={classes.menuButton}
        >
            {icon && <IconContainer>{icon}</IconContainer>}
            {label}
            {children}
        </Button>
    );
};

export default MenuButton;
